<script>
  import {ignore, makeWebsiteRequest} from "../../Common/tools";
  import {createEventDispatcher, onMount} from "svelte";
  import Table from "../../Table/Table.svelte";
  import ActiveColumns from "../../Contacts/Common/ActiveColumns.svelte";
  import {External, M} from "../../external";
  import Contact from '../../Contact/Contact.svelte';

  const dispatch = createEventDispatcher();

  export let filters = [],
    circleId = "all",
    onEmptyAction = ignore;

  let allItemsCount = null;
  let activeColumns = null;

  let selection = null;
  let loading = true;
  let initialLoad = true;
  let currentPage = 0;
  let pagesCount = 0;
  let table = null;
  let timeColumns = [];
  let helpVideoMarkup = "";

  let tableData = {
    columns: [],
    rows: []
  };

  let loadColumns = () => {
    if (!tableData.columns.length) {
      activeColumns = External.WebPlatform.getObjectFromLocalStorage("lmsMembersContactColumns", []);
      if (!activeColumns.length) {
        activeColumns = [-1, -2, 'tags'];
      }

      let count = 0;
      let columns = [];
      timeColumns = [];
      activeColumns.forEach(function (column) {
        let prop = External.getById(External.Website.crmProperties, column);
        if (prop) {
          let key = "col" + count++;
          columns.push({
            key: key,
            isNameColumn: column === -1,
            isEmailColumn: column === -2,
            label: prop.label,
            class: prop.id === -1 ? "flex-1 mw-240" : "flex-none"
          });

          if (prop.type === "DATE") {
            timeColumns.push(key);
          }
        } else {
          switch (column) {
            case "created":
              columns.push({
                key: column,
                label: M.CREATED,
                class: "flex-none"
              });
              timeColumns.push(column);
              break;
            case "tags":
              columns.push({
                key: column,
                label: M.TAGS,
                class: "flex-none"
              });
              break;
          }
        }
      });

      tableData.columns = columns;
    }
  };

  let load = async (page) => {
    if (loading && !initialLoad) {
      return;
    }
    initialLoad = false;

    if (page === 0) {
      loadColumns();
      tableData.rows = [];
    } else if (currentPage + 1 >= pagesCount) {
      return;
    }
    loading = true;

    let request = {
      page: page,
      columns: JSON.stringify(activeColumns),
      circleId: circleId
    };

    if (filters.length > 0) {
      request.filter = JSON.stringify(filters);
    }

    let response = await makeWebsiteRequest({
      action: "listLmsMembers",
      method: "get",
      data: request
    });

    loading = false;
    if (!response.data) {
      return;
    }

    currentPage = page;
    pagesCount = response.data.pagesCount;
    allItemsCount = response.data.count;

    if (timeColumns && timeColumns.length) {
      response.data.items.forEach(function (item) {
        timeColumns.forEach(function (column) {
          let value = item[column];
          if (value) {
            if (column !== "created") {
              value = value * 1000; // craeted is in milliseconds where date properties are in unix seconds
            }
            item[column] = External.Tools.dateToString(new Date(value), false);
          } else {
            item[column] = "";
          }
        });
      });
    }


    if (page === 0) {
      notifyItemsLoaded();
    }

    if (table) {
      table.addRows(response.data.items);
    }
  };

  let notifyItemsLoaded = () => {
    dispatch("itemsloaded", {
      count: allItemsCount
    });
  };

  let getSelectedItemsCount = () => {
    if (selection !== null) {
      if (selection.all) {
        return allItemsCount - selection.unselected.length;
      }
      else {
        return selection.selected.length;
      }
    }
    return allItemsCount;
  };

  export function reloadTable() {
    load(0);
  }

  export function showColumnOptions(event) {
    let columnItems = [];
    External.Website.crmProperties.forEach(function (property) {
      columnItems.push({
        id: property.id,
        label: property.label,
        disabled: property.id === -1 || property.id === -2, // name or email
        checked: activeColumns.indexOf(property.id) > -1
      });
    });

    columnItems.push({
      id: "tags",
      label: M.TAGS,
      checked: activeColumns.indexOf("tags") > -1
    });

    columnItems.push({
      id: "created",
      label: M.CREATED,
      checked: activeColumns.indexOf("created") > -1
    });

    External.Tools.showFloatingPopup({
      markup: '<div class="col20 f-left bound-popup"></div>',
      width: 250,
      target: External.$(event.target).closest("a"),
      customClass: "crm-filter-value",
      action: {
        onShow: function (popup, ui) {
          popup.bindComponent(
            new ActiveColumns({
              target: ui.find(".bound-popup")[0],
              props: {
                data: columnItems,
                change: function () {
                  let newColumns = [];
                  columnItems.forEach(function (column) {
                    if (column.checked) {
                      newColumns.push(column.id);
                    }
                  });
                  if (newColumns.indexOf(-1) < 0) {
                    newColumns.unshift(-1);
                  }
                  if (newColumns.indexOf(-2) < 0) {
                    newColumns.unshift(-2);
                  }

                  activeColumns = newColumns;
                  External.WebPlatform.setObjectToLocalStorage("lmsMembersContactColumns", activeColumns);
                  tableData.columns = [];
                  load(0);
                }
              }
            })
          );
        }
      }
    });
  }

  let onClick = (row) => {
    External.Tools.showWindow({
      isModal: false,
      withDarkBackground: true,
      width: 840,
      buttons: [],
      noNav: true,
      noTitle: true,
      forceAtRight: true,// window.showBuilderPopupsOnFullHeight,
      action: {
        onShow: (popup, ui) => {
          popup.bindComponent(new Contact({
            target: popup.getContentArea(),
            props: {
              id: row.id,
              inPopup: true,
              defaultTab: 'lms',
              onComponentReady: () => {

              }
            }
          }));
        }
      }
    });
  };

  let onNext = () => {
    load(currentPage + 1);
  };

  onMount(() => {
    if (External.Website.onboarding && External.Website.onboarding.lmsMembers) {
      helpVideoMarkup = External.CPanel.getEmbedVideo(External.Website.onboarding.lmsMembers);
    }
  });
</script>

<Table bind:this={table} activeColumns={tableData.columns} data={tableData.rows} loading={loading} bind:selection
       onClick={onClick} nextPage={onNext} hasSelection={false} hideHeadOnLoad={true}>
  <div class="text-center col20 f-left" style="padding: 70px 30px; box-sizing: border-box;">
    <h3 class="col20 f-left t-center mb-15">{M.NO_MEMBERS_YET}</h3>
    {#if helpVideoMarkup}
      <div class="col20 f-left mt-25">
        <div style="max-width: 600px; margin: 0 auto; display: block;">
          <div class="col20 f-left" style="padding:56.25% 0 0 0;position:relative;">
            <div class="full-size-abs" style="top: 0; left: 0">
              {@html helpVideoMarkup}
            </div>
          </div>
        </div>
      </div>
    {/if}
  </div>
</Table>
